export default "__VITE_ASSET__BaA3dBsV__"